module.exports = __webpack_public_path__ + "img/banner4.4c8c2826.png";